import { LitElement, html, css } from './-global.min.js'

export class HHAccordion extends LitElement {
  static properties = {
    button: { state: true },
    content: { state: true },
    slot: { state: true },
    forceOpen: {
      type: Boolean,
      attribute: 'force-open',
    },
    inherit: {
      type: Object,
      reflect: true,
    },
  }

  constructor() {
    super()

    this.parent = this.closest(`.${this.dataset.parent}`)
    this.accordions = this.parent?.querySelectorAll('.accordion') || []
  }

  firstUpdated() {
    super.firstUpdated()
    if (this.inherit) {
      this.parent = this.inherit
      this.accordions = this.parent?.querySelectorAll('.accordion') || []
    }
    this.maxHeight = this.getAttribute('max-height')
    this.initAccordion()

    if (this.forceOpen) {
      this.button.click()
    }
  }

  initAccordion() {
    this.slot = this.shadowRoot.querySelector('slot')
    for (const child of this.slot.assignedElements()) {
      if (child.tagName === 'BUTTON') {
        this.button = child
      } else {
        this.content = child
      }
    }

    this.initAccordionAction()
  }

  initAccordionAction() {
    if (this.button) {
      let slot = null
      this.button.addEventListener('click', (e) => {
        if (this.accordions.length > 1) {
          this.accordions.forEach(accordion => {
            if (accordion === this) return
            slot = accordion.shadowRoot.querySelector('slot')
            if (!slot) return
            for (const child of slot.assignedElements()) {
              if (child.tagName === 'BUTTON') {
                child.classList.remove('active')
              } else {
                child.style.maxHeight = null
              }
            }
            accordion.classList.remove('active')
          })
          window.dispatchEvent(
            new CustomEvent('accordionClick', {
              detail: {
                parent: this.dataset.parent,
                accordion: this,
              },
              bubbles: true,
              composed: true,
            })
          );
        }
        this.button.classList.toggle('active')
        if (this.content.style.maxHeight) {
          this.content.style.maxHeight = null
        } else {
          this.content.style.maxHeight = 'max-content'
        }
        this.classList.toggle('active')
      })
    }
  }

  // Call by component-metafield-accordion.js
  close() {
    this.button.classList.remove('active')
    this.content.style.maxHeight = null
    this.classList.remove('active')
  }

  render() {
    return html`
      <div class="accordion-wrapper">
        <slot></slot>
      </div>
    `
  }
}

customElements.define('hh-accordion', HHAccordion)
